<template>
  <div>
    <ProvidersListHero />

    <v-container>
      <div class="provider-grid">
        <CategorySection
          title="Attorneys"
          :description="descriptions.attorney"
          category="attorney"
          :providers="providers.attorney">

        </CategorySection>

        <CategorySection
          title="E&O Providers"
          :description="descriptions.eo"
          category="eo"
          :providers="providers.eo">

        </CategorySection>

        <CategorySection
          title="Compliance Consultants"
          :description="descriptions.compliance"
          category="compliance"
          :providers="providers.compliance">

        </CategorySection>

        <CategorySection
          title="CPAs"
          :description="descriptions.cpa"
          category="cpa"
          :providers="providers.cpa">

        </CategorySection>
      </div>
    </v-container>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import CategorySection from '../../components/CategorySection'
import ProvidersListHero from '../../components/ProvidersListHero'

export default {
  name: 'ProvidersListAll',
  components: {
    CategorySection,
    ProvidersListHero,
  },

  data: () => ({
    providers: {
      attorneys: [],
      eo: [],
      compliance: [],
      cpa: [],
    },
  }),

  computed: {
    ...mapGetters('feathers', ['apiProviders']),
    ...mapState({
      descriptions: state => state.providerDescriptions || {},
    }),
  },

  created () {
    this.getProviders()
  },

  methods: {
    async getProviders () {
      const query = type => ({
        query: {
          type,
          $limit: 3,
          $sort: {
            reviewScore: -1,
          },
        },
      })

      try {
        const results = await Promise.all([
          this.apiProviders.find(query('attorney')),
          this.apiProviders.find(query('eo')),
          this.apiProviders.find(query('compliance')),
          this.apiProviders.find(query('cpa')),
        ])

        this.providers.attorney = results[0].data
        this.providers.eo = results[1].data
        this.providers.compliance = results[2].data
        this.providers.cpa = results[3].data
      } catch (error) {
        this.addErrorAlert('Sorry, there was an error getting provider information, please try reloading the page')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.provider-grid {
  margin: 40px 0 100px;

  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 30px 0;

  @include lg {
    grid-template-columns: 1fr 1fr;
    grid-gap: 40px 60px;
  }
}
</style>
